<template>
  <div class="app-page home">
    <vue-headful title="ALICE | Dashboard"></vue-headful>
    <div class="home-wrapper">
      <div class="row head-row">
        <div class="col-6">
          <div class="head-title">
            <span class="icon">
              <font-awesome-icon icon="robot"></font-awesome-icon>
            </span>
            <span>Dashboard</span>
          </div>
        </div>
        <div class="col-6 bulma-dropdown" align="right">
          <b-dropdown id="date-filter" aria-role="list" position="is-bottom-left" :class="{'disabled': !loadingState}">
            <div class="btn btn-link text-secondary" slot="trigger" role="button">
              <font-awesome-icon class="text-primary-300" icon="filter"></font-awesome-icon>
                {{ channelFilter.toUpperCase() }}
              <i class="fa fa-angle-down ml-1"></i>
            </div>
            <b-dropdown-item
              v-for="ch in channelListData"
              :value="ch"
              :key="ch"
              aria-role="listitem" @click="toggleChannelFilter(ch)">
              {{ ch.toUpperCase() }}
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown id="date-filter" aria-role="list" position="is-bottom-left" :class="{'disabled': !loadingState}">
            <div class="btn btn-link text-secondary" slot="trigger" role="button">
              <font-awesome-icon class="text-primary-300 mr-1" icon="calendar"></font-awesome-icon>
              {{currentDateFilterString}}
              <i class="fa fa-angle-down ml-1"></i>
            </div>
            <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('today')">
              Today
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('yesterday')">
              Yesterday
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last7days')">
              Last 7 days
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last28days')">
              Last 28 days
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('custom')">
              Custom
            </b-dropdown-item>
          </b-dropdown>
          <date-range-picker
              v-show="dateFilter === 'custom'"
              v-model="dateRange"
              :ranges="false"
              :show-dropdowns="true"
              :maxDate="maxDate"
              :date-format="dateFormat"
              opens="left"
              @start-selection="setStartDateSelection"
              @finish-selection="setEndDateSelection"
              @toggle="onCalendarToggle">
            <div slot="input">
              {{ formatDate(this.dateRange.startDate) }} - {{ formatDate(this.dateRange.endDate) }}
            </div>
<!--            <template v-slot:input="picker" style="min-width: 350px;">-->
<!--              {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}-->
<!--            </template>-->
          </date-range-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xl-2">
          <div class="card bg-blue-300 stat-card">
            <div class="card-header">TOTAL USERS</div>
            <div class="card-body has-bg-image">
              <div class="media">
                <div class="media-body">
                  <h1 class="mb-0 text-semi-bold stat-value">{{totalUser | number}}</h1>
                </div>
                <div class="ml-3 align-self-center">
                  <em class="icon-users icon-3x opacity-75"></em>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-10">
          <bot-knowledge-widget></bot-knowledge-widget>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xl-4">
          <div id='loading' :class="{'d-none': loadingState}">
            <div style='position: absolute; z-index: 10;'>
              <img src='../assets/images/ui_loading.png'>
            </div>
          </div>
          <bot-performance-widget :criteria="currentCriteria"></bot-performance-widget>
        </div>
        <div class="col-sm-12 col-xl-8">
          <div id='loading' :class="{'d-none': loadingState}">
            <div style='position: absolute; z-index: 10;'>
              <img src='../assets/images/ui_loading.png'>
            </div>
          </div>
          <active-user-widget :criteria="currentCriteria"></active-user-widget>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <incoming-message-widget :criteria="currentCriteria"></incoming-message-widget>
        </div>
        <!-- <div class="col-sm-12 col-xl-3">
          <div class="card widget-card">
            <div class="card-header">USER SATISFACTION</div>
          </div>
        </div>-->
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <message-flow-widget :criteria="currentCriteria"></message-flow-widget>
          <rating-wedget
            v-if="selectedDate"
            :selectedDate="selectedDate"
            :channelFilter="channelFilter">
          </rating-wedget>
        </div>
        <div class="col-sm-12 col-md-6">
          <div id='loading' :class="{'d-none': loadingState}">
            <div style='position: absolute; z-index: 10;'>
              <img src='../assets/images/ui_loading.png'>
            </div>
          </div>
          <rulebase-match-widget :criteria="currentCriteria"></rulebase-match-widget>
        </div>
      </div>
<!--      <div class="row">-->
<!--        <div class="col-sm-12">-->
<!--          <message-category-widget :criteria="currentCriteria"></message-category-widget>-->
<!--        </div>-->
<!--        &lt;!&ndash; <div class="col sm-3">-->
<!--          <div class="card widget-card">-->
<!--            <div class="card-header">COMMON PHRASES</div>-->
<!--          </div>-->
<!--        </div>&ndash;&gt;-->
<!--      </div>-->
<!--      <div class="row">-->
<!--        <div class="col-sm-12">-->
<!--          <rule-base-tree-widget :criteria="currentCriteria"></rule-base-tree-widget>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

import IncomingMessageWidget from '../components/DashboardWidgets/IncomingMessageWidget.vue';
import ActiveUserWidget from '../components/DashboardWidgets/ActiveUserWidget.vue';
import MessageByFlowWidget from '../components/DashboardWidgets/MessageByFlowWidget.vue';
import RuleBaseMatchWidget from '../components/DashboardWidgets/RuleBaseMatchWidget.vue';
import BotKnowledgeWidget from '../components/DashboardWidgets/BotKnowledgeWidget.vue';
import BotPerformanceWidget from '../components/DashboardWidgets/BotPerformanceWidget.vue';
import RatingWidget from '../components/DashboardWidgets/RatingWidget.vue';

export default {
  name: 'home',
  components: {
    'incoming-message-widget': IncomingMessageWidget,
    'active-user-widget': ActiveUserWidget,
    'message-flow-widget': MessageByFlowWidget,
    'rulebase-match-widget': RuleBaseMatchWidget,
    'bot-knowledge-widget': BotKnowledgeWidget,
    'bot-performance-widget': BotPerformanceWidget,
    'rating-wedget': RatingWidget,
  },
  data() {
    return {
      dateFilter: 'last28days',
      loadingState: false,
      maxDate: null,
      originStartDate: moment().startOf('day'),
      originEndDate: moment().endOf('day'),
      isSelectedStartDate: false,
      isSelectedEndDate: false,
      selectedStartDate: null,
      selectedEndDate: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      channelFilter: 'all',
    };
  },
  created() {
    // we do this to prevent ui bug
    this.maxDate = moment(this.originStartDate).add(1, 'M').toISOString();

    this.selectedStartDate = this.originStartDate.toISOString();
    this.selectedEndDate = this.originEndDate.toISOString();

    this.dateRange.startDate = this.originStartDate.toISOString();
    this.dateRange.endDate = this.originEndDate.toISOString();
  },
  async mounted() {
    this.initFilterTotalUser();
    // await this.loadTotalUserData();
    // await this.getSatisfactionSummary();

    this.loadAvailableChannel();
    this.loadingState = true;
  },
  methods: {
    ...mapActions({
      loadAvailableChannel: 'log/loadAvailableChannel',
      loadTotalUserData: 'dashboard/loadTotalUserData',
      getSatisfactionSummary: 'satisfaction/getSatisfactionSummary',
    }),
    async initFilterTotalUser() {
      await this.loadTotalUserData({
        criteria: this.currentCriteria,
      });
    },
    toggleDateFilter(value) {
      if (this.dateFilter !== value) {
        this.dateFilter = value;
      }
      this.initFilterTotalUser();
    },
    async onCalendarToggle(isCalendarOpen) {
      if (isCalendarOpen === false) {
        if (this.isSelectedStartDate && this.isSelectedEndDate) {
          await this.customDates();
        } else {
          this.isSelectedStartDate = false;
          this.isSelectedEndDate = false;
          this.selectedStartDate = this.originStartDate.toISOString();
          this.selectedEndDate = this.originEndDate.toISOString();
        }
      }
    },
    dateFormat (classes, date) {
      const newClasses = classes;
      if (!newClasses.disabled) {
        if (this.isSelectedStartDate && this.selectedStartDate) {
          newClasses.disabled = date.getTime() < this.selectedStartDate || date.getTime() > new Date();
        } else {
          newClasses.disabled = date.getTime() > new Date();
        }
      }
      return newClasses;
    },
    setStartDateSelection(date) {
      if (date) {
        this.isSelectedStartDate = true;
        this.selectedStartDate = date;
      }
    },
    setEndDateSelection(date) {
      if (date) {
        this.isSelectedEndDate = true;
        this.selectedEndDate = date;
      }
    },
    async customDates() {
      if (this.isSelectedStartDate && this.isSelectedEndDate) {
        if (this.selectedEndDate < this.selectedStartDate) {
          this.dateRange.startDate = this.selectedEndDate;
          this.dateRange.endDate = this.selectedStartDate;
        } else {
          this.dateRange.startDate = this.selectedStartDate;
          this.dateRange.endDate = this.selectedEndDate;
        }
      }

      this.isSelectedStartDate = false;
      this.isSelectedEndDate = false;
      this.selectedStartDate = this.originStartDate.toISOString();
      this.selectedEndDate = this.originEndDate.toISOString();
      await this.initFilterTotalUser();
    },
    formatDate(str) {
      return moment(str).format('ll');
    },
    toggleChannelFilter(value) {
      this.channelFilter = value;
      this.initFilterTotalUser();
    },
  },
  computed: {
    ...mapGetters({
      channelList: 'log/channelList',
      totalUserData: 'dashboard/totalUserData',
      satisfactionSummaryData: 'satisfaction/satisfactionSummaryData',
    }),
    currentCriteria() {
      let untilDate = moment().utcOffset(420).endOf('day').toISOString();
      let sinceDate;
      let granularity;
      if (this.dateFilter === 'today') {
        sinceDate = moment()
          .startOf('day')
          .toISOString();
        granularity = 'hour';
      } else if (this.dateFilter === 'yesterday') {
        sinceDate = moment()
          .subtract(1, 'days')
          .startOf('day')
          .toISOString();
        untilDate = moment()
          .subtract(1, 'days')
          .endOf('day')
          .toISOString();
        granularity = 'hour';
      } else if (this.dateFilter === 'last7days') {
        sinceDate = moment()
          .utcOffset(420)
          .subtract(6, 'days')
          .startOf('day')
          .toISOString();
        granularity = 'day';
      } else if (this.dateFilter === 'last28days') {
        sinceDate = moment()
          .utcOffset(420)
          .subtract(27, 'days')
          .startOf('day')
          .toISOString();
        granularity = 'day';
      } else if (this.dateFilter === 'custom') {
        untilDate = moment(this.dateRange.endDate).utcOffset(420).endOf('day');
        sinceDate = moment(this.dateRange.startDate).utcOffset(420).startOf('day');
        const since = moment(sinceDate);
        const until = moment(untilDate);
        const diff = until.diff(since, 'days', true);
        if (diff <= 1) granularity = 'hour';
        else if (diff <= 31) granularity = 'day';
        else granularity = 'month';
      }
      if (sinceDate) {
        if (this.channelFilter !== 'all') {
          return {
            time: {
              sinceDate,
              untilDate,
              granularity,
            },
            channel: this.channelFilter,
          };
        }
        // channel = all
        return {
          time: {
            sinceDate,
            untilDate,
            granularity,
          },
        };
      }
      return {};
    },
    currentDateFilterString() {
      switch (this.dateFilter) {
        case 'today':
          return 'Today';
        case 'yesterday':
          return 'Yesterday';
        case 'last7days':
          return 'Last 7 days';
        case 'last28days':
          return 'Last 28 days';
        case 'custom':
          return 'Custom';
        default:
          return '';
      }
    },
    totalUser() {
      if (this.totalUserData) {
        return this.totalUserData.totalUser;
      }
      return 0;
    },
    channelListData() {
      const result = ['all'];
      if (this.channelList && this.channelList.length > 0) {
        for (const ch of this.channelList) {
          result.push(ch);
        }
      }
      return result;
    },
    selectedDate () {
      if (this.currentCriteria && this.currentCriteria.time) {
        return {
          from: this.currentCriteria.time.sinceDate,
          to: this.currentCriteria.time.untilDate,
        };
      }
      return null;
    }
  },
};
</script>
<style lang="scss" scoped>
.home {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  .head-row {
    margin-bottom: 15px;
    .head-title {
      font-size: 1.25rem;
      line-height: 2rem;
      font-weight: 500;
      display: flex;
      .icon {
        margin-right: 0.5rem;
        display: inline-block;
        svg {
          vertical-align: 0;
          height: 1rem;
        }
      }
    }

    .capitalize {
      text-transform: capitalize;
    }
  }
  .home-wrapper {
    padding: 15px;
    .stat-card {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      min-height: 125px;
      .card-header {
        font-size: 0.75rem;
        padding-bottom: 0;
      }
      .card-body {
        padding-bottom: 1rem;
        .stat-value {
          font-size: 1.5rem;
          line-height: 4rem;
        }
        .icon-right {
          flex: 0 0 auto;
          text-align: right;
          line-height: 4rem;
          .icon {
            font-size: 3rem;
            margin-right: 10px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
    .widget-card {
      .card-header {
        font-size: 1rem;
      }
    }
  }
}
#loading{
    position: absolute;
    width: 97%;
    height: 95%;
    display: flex;
    justify-content: center;
    background: darkgrey;
    align-items: center;
    z-index: 2;
    opacity: 0.2;
}
.disabled{
  pointer-events:none;
}
</style>
